"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetCampaignPoints = void 0;
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _shoppingContext = require("@ori/shopping-context");
var _constants = require("./constants");
// istanbul ignore file -- api
const useGetCampaignPoints = (param)=>{
    let { isCampaignOffer, offerId } = param;
    const { tenant } = (0, _environment.useEnvironment)();
    const sessionId = (0, _shoppingContext.useSessionId)();
    const enabled = isCampaignOffer && !!sessionId;
    const { data } = (0, _globalApiClientReact.useGetShoppingSessionCampaignPoints)(sessionId, offerId, {
        [_fetching.TENANT_CONTEXT]: tenant
    }, {
        swr: {
            // fix type in utils
            ...(0, _constants.getRetryErrorSwrOptions)(),
            enabled
        }
    });
    return data;
};
exports.useGetCampaignPoints = useGetCampaignPoints;
